import React from 'react';

import { CoreIcon } from '@aspid/ui';
import { Chip, Menu as MuiMenu, MenuItem as MuiMenuItem, Typography } from '@mui/material';

import { IconCollection } from '@components/icons/iconCollection';

import type { LinkTypeSelectorProperties } from './LinkTypeSelector.types';

export const LinkTypeSelector: React.FC<LinkTypeSelectorProperties> = ({
  linkTypeDisplayValue = '',
  linkTypeChoices,
  onTypeChange,
  dataTest = 'link_type_selector',
}) => {
  const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | undefined>();

  if (!linkTypeChoices || !onTypeChange) {
    return (
      <Typography
        data-testid={`${dataTest}_text`}
        sx={{
          fontSize: '11px',
          color: 'text.secondary'
        }}>
        {linkTypeDisplayValue}
      </Typography>
    );
  }

  return (
    <>
      <Chip
        data-testid={`${dataTest}_chip`}
        label={linkTypeDisplayValue}
        size='small'
        onClick={(event) => setMenuAnchor(event.currentTarget)}
        onDelete={(event) => setMenuAnchor(event.currentTarget as HTMLElement)}
        deleteIcon={<CoreIcon icon={IconCollection.caretDown} sx={{ fontSize: 10, cursor: 'pointer' }} />}
        variant='outlined'
        sx={{ fontSize: '11px', height: 22, cursor: 'pointer' }}
      />
      <MuiMenu
        data-testid={`${dataTest}_menu`}
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(undefined)}
      >
        {linkTypeChoices.map(choice => (
          <MuiMenuItem
            key={choice.value}
            data-testid={`${dataTest}_option_${choice.value}`}
            selected={choice.display_name === linkTypeDisplayValue}
            onClick={() => {
              onTypeChange(choice.value);
              setMenuAnchor(undefined);
            }}
            sx={{ fontSize: '13px' }}
          >
            {choice.display_name}
          </MuiMenuItem>
        ))}
      </MuiMenu>
    </>
  );
};
